<div style="display: inline-block;" [innerHTML]="value"></div>&nbsp;<button [matMenuTriggerFor]="aiTreeActions" (click)="info()" mat-stroked-button>action</button>&nbsp;
<mat-menu class="primary" #aiTreeActions="matMenu">
<!--  <button (click)="rename()" mat-menu-item>Rename</button>-->
  <button (click)="megaRename()" mat-menu-item>⚡️ Mega Rename</button>
  <button (click)="remove()" mat-menu-item>Delete</button>
  <hr>
  <button (click)="reRunGpt()" mat-menu-item>Re-run (Current category)</button>
  <button (click)="reRunGptNestedCat()" mat-menu-item>Re-run (Includes all nested categories)</button>
</mat-menu>
<!--<button (click)="edit()">action</button>-->
<!--{{value}}-->
